import { useTheme } from "next-themes";
import { Toaster as Sonner, toast } from "sonner";
import { isNativePlatform } from "@/lib/platform";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();
  const isNative = isNativePlatform();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className={`toaster group${isNative ? " mobile-centered-toaster" : ""}`}
      position={isNative ? "top-center" : "top-center"}
      offset={isNative ? 0 : 120}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          error:
            "group-[.toaster]:!bg-red-50 group-[.toaster]:!text-red-800 group-[.toaster]:!border-red-200",
          description: "group-[.toast]:text-muted-foreground",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
